import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AddressWithErrors } from "../../../models/AwarenessCampaign";
import { RootState } from "../../store";
import { Address } from "../../../models/Address";

interface AddressReportState {
    isFormOpen: boolean;
    selectedAddress: AddressWithErrors | null;
    userAddressLoading: boolean;
    newAddress: Address;
}

const EMPTY_ADDRESS: Address = {
    houseNumber: "",
    street: "",
    postalCode: "",
    city: "",
}

const initialState: AddressReportState = {
    isFormOpen: false,
    selectedAddress: null,
    userAddressLoading: false,
    newAddress: EMPTY_ADDRESS,
};

const addressReportSlice = createSlice({
    name: 'address_report',
    initialState,
    reducers: {
        openReportForm: (state, action: PayloadAction<AddressWithErrors | null>) => {
            state.isFormOpen = true;
            state.selectedAddress = action.payload;
        },
        closeReportForm: (state) => {
            state.isFormOpen = false;
            state.selectedAddress = null;
        },
        setSelectedAddress: (state, action: PayloadAction<AddressWithErrors | null>) => {
            state.selectedAddress = action.payload;
        },
        startLoadingUserAddress: (state) => {
            state.userAddressLoading = true;
        },
        stopLoadingUserAddress: (state) => {
            state.userAddressLoading = false;
        },
        setUserAddress: (state, action: PayloadAction<Address>) => {
            state.newAddress = action.payload;
            state.userAddressLoading = false;
        },
        updateAddressField: (state, action: PayloadAction<{ field: keyof Address, value: string }>) => {
            state.newAddress = { 
                ...state.newAddress, 
                [action.payload.field]: action.payload.value
            };
        },
    },
});

export const AddressReportActions = addressReportSlice.actions;

// Selectors
export const selectIsReportFormOpen = (state: RootState) => state.awareness_campaign.address_report.isFormOpen;
export const selectSelectedAddress = (state: RootState) => state.awareness_campaign.address_report.selectedAddress;

const AddressReportReducer = addressReportSlice.reducer;

export default AddressReportReducer;
